import React from 'react';

/**
 * Maintenance Page
 *
 * Displayed when the API returns 503 with status 'MAINTENANCE'.
 * Uses the designed maintenance background image.
 */
const MaintenancePage = () => {
    return (
        <div style={{
            width: '100%',
            height: '100vh',
            margin: 0,
            padding: 0,
            overflow: 'hidden',
            backgroundImage: 'url(/assets/images/page-maintenance.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }} />
    );
};

export default MaintenancePage;
